import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SET_IS_POST_IN_PREVIEW = 'isPostInPreview/SET';

export const setIsPostInPreview = createAction(SET_IS_POST_IN_PREVIEW);
